export const convert_category_link = ({ link, check_by }) => {
  check_by.forEach(({ checker_text, replace_by }) => {
    if (link.includes(checker_text)) {
      link = link.replace(checker_text, replace_by);
    }
  });
  return link;
};
